import { render, staticRenderFns } from "./StaffAssign.vue?vue&type=template&id=b2065490&scoped=true"
import script from "./StaffAssign.vue?vue&type=script&lang=js"
export * from "./StaffAssign.vue?vue&type=script&lang=js"
import style0 from "./StaffAssign.vue?vue&type=style&index=0&id=b2065490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2065490",
  null
  
)

export default component.exports